import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styles from './styles.scss';

export interface FAQSectionOneProps {
  localizeMessage: (key: string) => string;
}

export const FAQSectionOne: React.FC<FAQSectionOneProps> = ({ localizeMessage }) => (
  <Box mt={2}>
    <Typography
      variant="h6"
      style={{ fontWeight: 600 }}
      color="textSecondary"
      gutterBottom
      className={styles['faq-section-title']}
    >
      {localizeMessage('faqSectionCancellation')}
    </Typography>
    <div className={styles.faqCard}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" className={styles['faq-question']}>
            {localizeMessage('faqQ1')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={styles['faq-answer']}>{localizeMessage('faqA1')}</Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" className={styles['faq-question']}>
            {localizeMessage('faqQ2')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={styles['faq-answer']}>{localizeMessage('faqA2')}</Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" className={styles['faq-question']}>
            {localizeMessage('faqQ3')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={styles['faq-answer']}>{localizeMessage('faqA3')}</Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" className={styles['faq-question']}>
            {localizeMessage('faqQ4')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={styles['faq-answer']}>{localizeMessage('faqA4')}</Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  </Box>
);
